import { Button } from "@ui-library/core";
import { colorPalette, colors } from "_shared/styles/color";
import styled from "styled-components";
import MemoSvgBuyMore from "@local/icons/component/BuyMore"
import { XL_SCREEN_WIDTH } from "../DistributionModePick/DistributionModePick.types";

export const Container = styled.div`
    border-radius: 15px;
    background-color: ${colorPalette.lighterSaphir};
    display: inline-flex;
    margin-top: 25px;
    margin-bottom: 20px;
    height: 204px;
    width: 100%;
    @media (max-width: ${XL_SCREEN_WIDTH}px) {
        margin-top: 5px;
        height: 140px;
	}
`

export const ActionButton = styled(Button)`
    border: 2px solid ${colorPalette.saphir};
    color: ${colorPalette.saphir};
    max-width: 306px;
    flex-grow: 1;
    margin-right: 30px;
    background: rgba(255, 255, 255, 0.4);
    &:hover:before, :not(:disabled):hover {
        background: ${colorPalette.saphir} !important;
        color: white !important;
        border: 2px solid ${colorPalette.saphir} !important;
    }
`;

export const RightContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-grow: 1;
    margin-left: -190px;
    @media (max-width: ${XL_SCREEN_WIDTH}px) {
        margin-left: -130px;
	}
    z-index: 2;
`;

export const Title = styled.h1`
    font-size: 36px;
    margin-bottom: 10px;
    color: ${colorPalette.saphir};
    grid-row-start: 1;
    grid-row-end: 2;
    background-color: ${colorPalette.lighterSaphir};
    box-shadow: 0px 30px 34px 25px ${colorPalette.lighterSaphir};
    @media (max-width: ${XL_SCREEN_WIDTH}px) {
        font-size: 26px;
        margin-bottom: 5px;
	}
`;

export const LightText = styled.span`
    color: ${colorPalette.saphir};
    font-size: 18px;
    line-height: 30px;
    grid-row-start: 1;
    grid-row-end: 1;
    width: 450px;
    text-shadow: rgba(232, 233, 253, 0.5);
    background-color: ${colorPalette.lighterSaphir};
    box-shadow: 0px 39px 63px 31px ${colorPalette.lighterSaphir};
    @media (max-width: ${XL_SCREEN_WIDTH}px) {
        font-size: 16px;
        box-shadow: 0px 20px 25px 8px ${colorPalette.lighterSaphir};
    }
`;

export const BuyMorePicture = styled(MemoSvgBuyMore)`
    position: relative;
    right: 35px;
    bottom: 69px;
    height: 273px ;
    @media (max-width: ${XL_SCREEN_WIDTH}px) {
        bottom: 40px;
        height: 180px;
    }
`;

export const Row = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;